import Text from '@shared/components/content/text';
import { Button, ButtonProps } from '@shared/components/ui/button';
import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

interface GuideEditTemplateProps {
  preTitle?: string;
  children: ReactNode;
  primaryActionText: string | ReactNode;
  primaryActionProps?: ButtonProps;
  secondaryActionText?: string | ReactNode;
  secondaryActionProps?: ButtonProps;
  destructiveActionText?: string | ReactNode;
  destructiveActionProps?: ButtonProps;
  className?: string;
}

export default function GuideEditTemplate({
  preTitle = 'Getting started',
  children,
  className,
  primaryActionText,
  primaryActionProps,
  secondaryActionText,
  secondaryActionProps,
  destructiveActionText,
  destructiveActionProps,
}: GuideEditTemplateProps) {
  return (
    <div
      className={cn(
        'flex size-full items-center justify-center p-2 md:p-0',
        className
      )}
    >
      <div className="flex min-h-[586px] w-[700px] flex-col items-center text-center ">
        <Text
          className={cn('mb-4 uppercase font-bold', {
            'opacity-0': !preTitle,
          })}
        >
          {preTitle}
        </Text>
        <div className="max-w-5xl">{children}</div>
        <div className="mx-auto mt-12 flex w-full justify-between">
          {destructiveActionText && (
            <div className="flex  flex-1 items-center justify-start">
              <Button
                variant="destructive"
                type="button"
                {...destructiveActionProps}
              >
                {destructiveActionText}
              </Button>
            </div>
          )}
          <div
            className={cn('flex items-center justify-between space-x-2', {
              'flex-1': !destructiveActionText,
            })}
          >
            {secondaryActionText && (
              <Button
                variant="secondary"
                className="border border-primary-700 text-primary-700"
                {...secondaryActionProps}
              >
                {secondaryActionText}
              </Button>
            )}

            <Button className="bg-primary-700" {...primaryActionProps}>
              {primaryActionText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
